import { useEffect, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import { getUserRedemption } from '../api';
import { HistoryItemCard, loginLogout, useProjectByStorage } from '../projectData';
import { useRouteData } from '../RouteDataContext';
import { FullPageLoader } from '../../component/helper';


/**
 * RedeemHistory component
 * Displays the user's redemption history, fetching data from the API and rendering each redemption record and its items.
 * Handles loading state and empty history display.
 */
export const RedeemHistory = () => {
    const { userData } = useRouteData();
    const [redemList, setRedemList] = useState([{}]);
    const project = useProjectByStorage();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setLoader(true)
        if (userData && project) {
            getUserRedemption({ project_key: project?.pkey }).then((d) => {
                setRedemList(d?.data)

                setTimeout(() => {
                    setLoader(false)
                }, 500);

            }).catch((error) => {
                loginLogout(error.response)
            })
        }
    }, [project, userData])

    return (
        <div className='container bg-white mb-4 vh-100'>
            <div style={{ background: '#fefafa' }} className='card mb-4'>
                <div className='card-body p-3 fs-5'>
                    Below are your redemption History.
                </div>
            </div>
            <div className="row">
                {Array.isArray(redemList) && redemList.length > 0 ?
                    redemList.map((data, index) => (
                        <div className='col-sm-4 mt-4'>
                            <div className="card  p-2" style={{ border: '1px solid #eaeaea', backgroundColor: "#EFEFEF" }}>
                                <div className="d-flex justify-content-between  p-2 ">
                                    <div className="fw-semibold fs-6">Redemption Id: <span className='fw-semibold'>{data?.order_id}</span></div>
                                    <div className="fw-semibold fs-6">Date:<span className='fw-semibold'> {data?.order_date}</span> </div>
                                </div>
                                <>
                                    {data?.items?.map((item, index) => (
                                        <HistoryItemCard data={item} url={`/customer/user-redem-detail/${item?.id}`} />
                                    ))}
                                </>
                            </div>
                        </div>))
                    : <div style={{ background: '#fefafa' }} className='card mt-3 mb-4'>
                        {!loader &&
                            <div className='card-body p-4'>
                                <div className="notice d-flex bg-light-danger rounded border-primary border border-dashed mt-5 mb-9 p-6">
                                    <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                        <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger' />
                                    </span>
                                    <div className="d-flex flex-stack flex-grow-1">
                                        <div className="fw-semibold">
                                            <div className="fs-6 text-gray-700 gap-3 ">No item found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            {loader &&
                <FullPageLoader />
            }
        </div>
    )
}
